/**
 * CTA Click Tracking
 *
 * Fires PostHog events when users click signup or login CTAs.
 *
 * Events:
 *   signup_cta_click  – link pointing to accounts.coingate.com/register (or /sign-up)
 *   login_cta_click   – link pointing to accounts.coingate.com/login   (or /sign-in)
 *
 * Properties sent with each event:
 *   cta_location  – where on the page the button was: navigation | hero | content | sidebar | footer
 *   cta_text      – visible button label
 *   page_path     – current page path (e.g. /accept-payments)
 */

const ACCOUNTS_HOST = 'accounts.coingate.com';

function getCtaType(url) {
  try {
    const { hostname, pathname } = new URL(url, window.location.href);
    if (hostname !== ACCOUNTS_HOST) return null;
    if (/\/(register|sign-up)(\/|$|\?)/i.test(pathname)) return 'signup';
    if (/\/(login|sign-in)(\/|$|\?)/i.test(pathname)) return 'login';
    // Accounts root is the signup method chooser
    if (pathname === '/' || pathname === '') return 'signup';
  } catch {
    // Malformed URL — skip
  }
  return null;
}

function getCtaLocation(el) {
  const container = el.closest('[data-cta-location]');
  return container ? container.dataset.ctaLocation : 'unknown';
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]');
  if (!link) return;

  const type = getCtaType(link.href);
  if (!type) return;

  if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') return;

  const eventName = type === 'signup' ? 'signup_cta_click' : 'login_cta_click';

  window.posthog.capture(eventName, {
    cta_location: getCtaLocation(link),
    cta_text: (link.textContent || '').trim() || link.getAttribute('aria-label') || '',
    page_path: window.location.pathname,
  });
}, { passive: true });
